<template>
  <div class="app-container">
    <!-- 筛选栏 -->
    <!-- 筛选栏表单，使用行内布局 -->
    <el-form :inline="true" v-model="searchForm" class="demo-form-inline">
      <!-- 真实姓名输入框 -->
      <el-form-item label="真实姓名">
        <el-input v-model="searchForm.searchRealName" placeholder="输入姓名" />
      </el-form-item>
      <el-form-item label="角色">
        <el-select v-model="searchForm.searchRoleId" placeholder="请选择角色" clearable>
          <el-option label="学生" :value="1" />
          <el-option label="教师" :value="2" />
          <el-option label="管理员" :value="3" />
          <el-option label="年级主任" :value="4" />
          <el-option label="家长" :value="5" />
          <el-option label="机构" :value="6" />
        </el-select>
      </el-form-item>
      <!-- 班级选择器组件 -->
      <el-form-item label="班级">
        <ClassSelect v-model="searchForm.searchClass" :is-multiple="false" />
      </el-form-item>
      <el-form-item label="会员类别">
        <el-select v-model="searchForm.searchMembershipType" placeholder="请选择会员类别" clearable filterable>
          <el-option
            v-for="item in membershipFilterOptions"
            :key="`${item.courseTypeCode}_${item.subjectCode}`"
            :label="item.label"
            :value="`${item.courseTypeCode}__${item.subjectCode || ''}`"
          />
        </el-select>
      </el-form-item>
      <el-form-item label="用户分组">
        <el-select v-model="searchForm.searchGroupId" placeholder="请选择分组" clearable filterable>
          <el-option
            v-for="item in userGroups"
            :key="item.id"
            :label="item.groupName"
            :value="item.id"
          />
        </el-select>
      </el-form-item>
      <!-- 操作按钮组 -->
      <el-form-item>
        <el-button type="primary" @click="searchUser">查询</el-button>
        <el-button
          v-if="role == 'admin' || role == 'mteacher'"
          type="warning"
          :loading="bulkActivateLoading"
          @click="activateMembershipsByCurrentFilter"
        >一键开通所有会员</el-button>
        <el-button
          v-if="role == 'admin' || role == 'mteacher'"
          type="danger"
          :loading="bulkRevokeLoading"
          @click="revokeMembershipsByCurrentFilter"
        >一键撤回所有会员</el-button>
        <el-button type="primary" @click="addUserDiologVisible = true">新增</el-button>
        <el-button type="primary" @click="fileDialogVisible = true">导入</el-button>
        <el-button type="success" plain @click="groupDialogVisible = true">新建分组</el-button>
        <el-button type="warning" plain :disabled="selectedUsers.length === 0" @click="openAssignGroupDialog">加入分组</el-button>
      </el-form-item>
    </el-form>

    <div class="group-management-panel">
      <div class="group-management-panel__sidebar">
        <div class="group-management-panel__header">
          <div class="group-management-panel__title">分组列表</div>
          <el-button type="success" size="mini" plain @click="groupDialogVisible = true">新建分组</el-button>
        </div>
        <div v-if="!userGroups.length" class="group-empty-state">暂无分组，先创建一个分组吧</div>
        <div v-else class="group-card-list">
          <div
            v-for="item in userGroups"
            :key="item.id"
            class="group-card"
            :class="{ 'group-card--active': activeGroupId === item.id }"
            @click="selectActiveGroup(item)"
          >
            <div class="group-card__main">
              <div class="group-card__name">{{ item.groupName }}</div>
              <div class="group-card__desc">{{ item.description || '暂无分组描述' }}</div>
            </div>
            <div class="group-card__actions">
              <el-button type="text" size="mini" @click.stop="openGroupUsersDialog(item)">查看</el-button>
              <el-button type="text" size="mini" style="color:red;" @click.stop="deleteGroup(item)">删除</el-button>
            </div>
          </div>
        </div>
      </div>

      <div class="group-management-panel__content">
        <div class="group-management-panel__header">
          <div>
            <div class="group-management-panel__title">分组成员管理</div>
            <div v-if="activeGroup" class="group-management-panel__subtitle">
              当前分组：{{ activeGroup.groupName }}
            </div>
          </div>
          <div>
            <el-button type="warning" size="mini" plain :disabled="!activeGroup" @click="openAddMembersDialogForActiveGroup">添加用户到分组</el-button>
            <el-button type="success" size="mini" plain :disabled="!activeStudentUsers.length || groupMembershipBatchLoading" @click="activateMembershipsByActiveGroup">开通本组会员</el-button>
            <el-button type="danger" size="mini" plain :disabled="!activeStudentUsers.length || groupMembershipBatchLoading" @click="revokeMembershipsByActiveGroup">撤回本组会员</el-button>
            <el-button type="primary" size="mini" plain :disabled="!activeGroup" @click="openGroupUsersDialog(activeGroup)">弹窗查看</el-button>
          </div>
        </div>

        <div v-if="activeGroup" class="group-detail-summary">
          <div class="group-detail-summary__name">{{ activeGroup.groupName }}</div>
          <div class="group-detail-summary__desc">{{ activeGroup.description || '暂无分组描述' }}</div>
          <div class="group-detail-summary__meta">成员数：{{ activeGroupUsers.length }}</div>
          <div class="group-detail-summary__meta">学生成员：{{ activeStudentUsers.length }}</div>
        </div>

        <div v-if="!activeGroup" class="group-empty-state">请选择左侧分组后查看和管理成员</div>
        <el-table v-else :data="activeGroupUsers" border fit>
          <el-table-column prop="userName" label="用户名" align="center" />
          <el-table-column prop="realName" label="真实姓名" align="center" />
          <el-table-column prop="roleId" label="角色" align="center">
            <template slot-scope="{ row }">
              <span>{{ formatRoleName(row.roleId) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gradeName" label="班级" align="center" />
          <el-table-column prop="phone" label="手机号" align="center" />
          <el-table-column label="会员管理" align="center" width="120">
            <template slot-scope="{ row }">
              <el-button
                v-if="row.roleId == 1 && (role == 'admin' || role == 'mteacher')"
                type="primary"
                size="mini"
                @click="openMembershipDialog(row)"
              >管理</el-button>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="120">
            <template slot-scope="{ row }">
              <el-button type="text" style="color:red;" @click="removeUserByGroup(activeGroup, row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <div class="summary-cards">
      <div class="summary-card">
        <div class="summary-card__label">人员总数</div>
        <div class="summary-card__value">{{ summaryStats.total }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-card__label">学生人数</div>
        <div class="summary-card__value">{{ summaryStats.students }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-card__label">教师人数</div>
        <div class="summary-card__value">{{ summaryStats.teachers }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-card__label">机构</div>
        <div class="summary-card__value">{{ summaryStats.organizations }}</div>
      </div>
      <div class="summary-card">
        <div class="summary-card__label">会员学生</div>
        <div class="summary-card__value">{{ summaryStats.vipStudents }}</div>
      </div>
    </div>

    <el-table :data="pagedRecords" border fit highlight-current-row @selection-change="handleSelectionChange" :header-cell-style="{
      background: '#f2f3f4',
      color: '#555',
      'font-weight': 'bold',
      'line-height': '32px',
    }">
      <el-table-column align="center" type="selection" width="55" />
      <el-table-column label="序号" align="center" width="80px">
        <template slot-scope="scope">
          {{ (pageNum - 1) * pageSize + scope.$index + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="userName" label="用户名" align="center" />
      <el-table-column prop="realName" label="真实姓名" align="center" />
      <el-table-column prop="roleId" label="角色名称" align="center" >
      <template slot-scope="{ row }">
        <span v-if="row.roleId == 1">学生</span>
        <span v-if="row.roleId == 2">教师</span>
        <span v-if="row.roleId == 3">管理员</span>
        <span v-if="row.roleId == 4">年级主任</span>
        <span v-if="row.roleId == 6">机构</span>
      </template>
      </el-table-column>
      <el-table-column label="分组" align="center" min-width="180">
        <template slot-scope="{ row }">
          <span v-if="!getUserGroupNames(row.id).length">-</span>
          <el-tag v-for="name in getUserGroupNames(row.id)" :key="`${row.id}_${name}`" size="mini" style="margin: 0 4px 4px 0;">{{ name }}</el-tag>
        </template>
      </el-table-column>

      <el-table-column label="会员管理" align="center" width="120">
        <template slot-scope="{ row }">
          <el-button
            v-if="row.roleId == 1 && (role == 'admin' || role == 'mteacher')"
            type="primary"
            size="mini"
            @click="openMembershipDialog(row)"
          >管理</el-button>
          <span v-else-if="row.roleId == 1">学生</span>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="gradeName" label="班级" align="center" />
      <el-table-column prop="createTime" label="注册时间" align="center" />
      <el-table-column align="center" label="操作">
        <template slot-scope="{ row }">
          <el-button v-if="role == 'admin'|| role == 'mteacher' || role == 'organization'" type="text" size="small" style="color: #409EFF; font-size: 14px"
            @click="openAmcOrderDialog(row)">购买记录</el-button>
          <el-button v-if="role == 'teacher'" type="text" size="small" style="color: red; font-size: 14px"
            @click="removeUserClass(row)">移除班级</el-button>
          <el-button v-if="role == 'admin'|| role == 'mteacher'" type="text" size="small" style="color: red; font-size: 14px"
            @click="delUser(row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog title="AMC购买记录" :visible.sync="amcOrderDialogVisible" width="900px">
      <div v-loading="amcOrderLoading">
        <el-table :data="amcOrders" border fit highlight-current-row :header-cell-style="{
          background: '#f2f3f4',
          color: '#555',
          'font-weight': 'bold',
          'line-height': '32px',
        }">
          <el-table-column prop="orderNo" label="订单号" align="center" min-width="180" />
          <el-table-column prop="courseType" label="课程类型" align="center" width="100" />
          <el-table-column prop="courseLevel" label="等级" align="center" width="110" />
          <el-table-column prop="amount" label="金额" align="center" width="90" />
          <el-table-column prop="status" label="状态" align="center" width="110">
            <template slot-scope="{ row }">
              <span v-if="row.status === 0">待支付</span>
              <span v-else-if="row.status === 1">已支付</span>
              <span v-else-if="row.status === 2">已取消</span>
              <span v-else-if="row.status === 3">已退款</span>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="payTime" label="支付时间" align="center" min-width="160" />
          <el-table-column prop="validStart" label="生效时间" align="center" min-width="160" />
          <el-table-column prop="validEnd" label="到期时间" align="center" min-width="160" />
          <el-table-column prop="payMethod" label="支付方式" align="center" width="110" />
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="amcOrderDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="新建用户分组" :visible.sync="groupDialogVisible" width="480px">
      <el-form :model="groupForm" label-width="90px">
        <el-form-item label="分组名称">
          <el-input v-model="groupForm.groupName" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="分组描述">
          <el-input v-model="groupForm.description" type="textarea" :rows="3" maxlength="200" show-word-limit />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="saveGroup">保 存</el-button>
      </div>
    </el-dialog>

    <el-dialog title="加入用户分组" :visible.sync="assignGroupDialogVisible" width="420px">
      <el-form label-width="90px">
        <el-form-item label="目标分组">
          <el-select v-model="assignGroupId" placeholder="请选择分组" style="width:100%;" filterable>
            <el-option v-for="item in userGroups" :key="item.id" :label="item.groupName" :value="item.id" />
          </el-select>
        </el-form-item>
        <el-form-item label="已选用户">
          <div>{{ selectedUsers.length }} 人</div>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="assignGroupDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="assignSelectedUsersToGroup">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :title="groupUsersDialogTitle" :visible.sync="groupUsersDialogVisible" width="760px">
      <el-table :data="groupUsers" border fit>
        <el-table-column prop="userName" label="用户名" align="center" />
        <el-table-column prop="realName" label="真实姓名" align="center" />
        <el-table-column prop="roleId" label="角色" align="center">
          <template slot-scope="{ row }">
            <span v-if="row.roleId == 1">学生</span>
            <span v-else-if="row.roleId == 2">教师</span>
            <span v-else-if="row.roleId == 3">管理员</span>
            <span v-else-if="row.roleId == 4">年级主任</span>
            <span v-else-if="row.roleId == 6">机构</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column prop="phone" label="手机号" align="center" />
        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="{ row }">
            <el-button type="text" style="color:red;" @click="removeUserFromCurrentGroup(row)">移除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupUsersDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加用户到分组" :visible.sync="groupMemberPickerVisible" width="900px">
      <div class="group-member-picker">
        <div class="group-member-picker__toolbar">
          <el-input v-model="groupMemberKeyword" placeholder="搜索用户名/真实姓名" clearable style="width: 280px;" />
          <div>目标分组：{{ activeGroup ? activeGroup.groupName : '-' }}</div>
        </div>
        <el-table :data="groupCandidateUsers" border fit @selection-change="handleGroupCandidateSelection">
          <el-table-column type="selection" width="55" align="center" />
          <el-table-column prop="userName" label="用户名" align="center" />
          <el-table-column prop="realName" label="真实姓名" align="center" />
          <el-table-column prop="roleId" label="角色" align="center">
            <template slot-scope="{ row }">
              <span>{{ formatRoleName(row.roleId) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="gradeName" label="班级" align="center" />
          <el-table-column label="当前分组" align="center" min-width="180">
            <template slot-scope="{ row }">
              <span v-if="!getUserGroupNames(row.id).length">-</span>
              <el-tag v-for="name in getUserGroupNames(row.id)" :key="`${row.id}_candidate_${name}`" size="mini" style="margin: 0 4px 4px 0;">{{ name }}</el-tag>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="groupMemberPickerVisible = false">取 消</el-button>
        <el-button type="primary" :disabled="groupCandidateSelected.length === 0" @click="confirmAddMembersToActiveGroup">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 会员管理弹窗 -->
    <el-dialog :title="membershipDialogTitle" :visible.sync="membershipDialogVisible" width="560px">
      <div v-loading="membershipDialogLoading">
        <div v-if="membershipTypes.length === 0" style="text-align:center; color:#909399; padding:20px 0;">暂无可管理的会员类型</div>
        <el-table v-else :data="membershipTypes" border fit :header-cell-style="{
          background: '#f2f3f4',
          color: '#555',
          'font-weight': 'bold',
          'line-height': '32px',
        }">
          <el-table-column prop="label" label="会员类型" align="center" />
          <el-table-column label="状态" align="center" width="160">
            <template slot-scope="{ row }">
              <el-switch
                :value="getIsVip(membershipDialogUserId, row.courseTypeCode, row.subjectCode)"
                active-text="会员"
                inactive-text="普通"
                @change="(val) => onToggleMembershipInDialog(row, val)"
              />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="membershipDialogVisible = false">关 闭</el-button>
      </div>
    </el-dialog>

    <!-- 新增弹窗 -->
    <el-dialog title="新增用户" :visible.sync="addUserDiologVisible">
      <el-form :model="addForm">
      <el-row>
        <el-col :span="11">
          <el-form-item label="用户名" :label-width="formLabelWidth">
            <el-input v-model="addForm.userName" autocomplete="off" />
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="真实姓名" :label-width="formLabelWidth">
            <el-input v-model="addForm.realName" autocomplete="off" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="身份选择" :label-width="formLabelWidth" v-if="role == 'admin'||role == 'mteacher'" >
            <el-select v-model="addForm.roleId" placeholder="请选择身份">
              <el-option label="学生" value="1" />
              <el-option label="教师" value="2" />
              <el-option label="机构" value="6" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <el-form-item label="班级选择" :label-width="formLabelWidth" v-if="role == 'teacher' || role == 'admin' || role == 'mteacher'" >
            <ClassSelect v-model="addForm.gradeId" :is-multiple="false" />
          </el-form-item>
        </el-col>
      </el-row>
    <!-- </el-row> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addUserDiologVisible = false">取 消</el-button>
        <el-button type="primary" @click="addUser">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 文件上传 -->
    <!-- 文件上传 -->
    <el-dialog width="400px" :show-close="false" :close-on-click-modal="false" title="上传文件"
      :visible.sync="fileDialogVisible">
      <el-upload class="upload-demo" drag action="xxxxxx" multiple :limit="1" accept=".xlsx, .xls" :auto-upload="false"
        :on-remove="handleRemove" :on-change="handleFileChange" :on-progress="handleProgress" :file-list="fileList">
        <i class="el-icon-upload" />
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div slot="tip" class="el-upload__tip">只能上传xls/xlsx文件，且不超过500kb,大小为12kb</div>
      </el-upload>
      <!-- 添加进度条 -->
      <el-progress v-if="uploadProgress > 0" :percentage="uploadProgress" />
      <div slot="footer" class="dialog-footer">
        <el-button @click="fileDialogVisible = false">取 消</el-button>
        <el-button type="success" plain @click="startDownload">下载模板</el-button>
        <el-button type="primary" @click="importUser">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分页 -->
    <div class="pagination-container">
      <el-pagination :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="filteredRecords.length" @size-change="handleSizeChange"
        @current-change="handleCurrentChange" />
    </div>
  </div>
</template>

<script>
import ClassSelect from '@/components/ClassSelect'
import { userPaging, classAdd, userDel, userImport } from '@/api/user'
import { userClassRemove } from '@/api/class'
import { listAmcOrdersByUserId } from '@/api/amcOrder'
import { batchUserMemberships, upsertUserMembership } from '@/api/userMembership'
import { fetchPaging as fetchRepoList } from '@/api/repo'
import { addUsersToGroup, batchUserGroups, deleteUserGroup, listGroupUsers, listUserGroups, removeUserFromGroup, saveUserGroup } from '@/api/userGroup'
export default {
  components: { ClassSelect },
  data() {
    return {
      // 当前登录角色
      role: '',
      pageNum: 1,
      pageSize: 10,
      // 分页查找的数据
      data: {},
      // 导入用户上传文件的文件列表
      fileList: [],
      // 新增用户对话框
      addUserDiologVisible: false,
      // 导入用户对话框
      fileDialogVisible: false,
      amcOrderDialogVisible: false,
      amcOrderLoading: false,
      amcOrders: [],
      membershipDialogVisible: false,
      membershipDialogLoading: false,
      membershipDialogUserId: null,
      membershipDialogUserName: '',
      membershipTypes: [],
      allRepos: [],
      userGroups: [],
      userGroupMap: {},
      selectedUsers: [],
      groupDialogVisible: false,
      assignGroupDialogVisible: false,
      assignGroupId: null,
      groupForm: {
        groupName: '',
        description: ''
      },
      groupUsersDialogVisible: false,
      currentGroupView: null,
      groupUsers: [],
      activeGroupId: null,
      activeGroupUsers: [],
      groupMemberPickerVisible: false,
      groupMemberKeyword: '',
      groupCandidateSelected: [],
      groupMembershipBatchLoading: false,
      bulkActivateLoading: false,
      bulkRevokeLoading: false,
      allFilteredRecords: [],
      // 新增用户表单
      addForm: {
        userName: '',
        realName: '',
        roleId: '',
        gradeId: ''
      },
      // 筛选栏表单
      searchForm: {
        searchRealName: '',
        searchClass: '',
        searchRoleId: '',
        searchMembershipType: '',
        searchGroupId: ''
      },
      membershipMap: {},
      // eslint-disable-next-line no-dupe-keys
      formLabelWidth: '80px'
    }
  },
  computed: {
    membershipDialogTitle() {
      return this.membershipDialogUserName ? `会员管理 - ${this.membershipDialogUserName}` : '会员管理'
    },
    membershipFilterOptions() {
      return this.getAllMembershipTypes()
    },
    filteredRecords() {
      const list = Array.isArray(this.allFilteredRecords) ? this.allFilteredRecords : []
      const membershipValue = this.searchForm.searchMembershipType
      let next = list
      if (membershipValue) {
        const [courseTypeCode, subjectCode = ''] = membershipValue.split('__')
        next = next.filter(row => this.getIsVip(row.id, courseTypeCode, subjectCode))
      }
      if (this.searchForm.searchGroupId) {
        next = next.filter(row => {
          const groupIds = this.userGroupMap[row.id] || []
          return groupIds.includes(this.searchForm.searchGroupId)
        })
      }
      return next
    },
    pagedRecords() {
      const start = (this.pageNum - 1) * this.pageSize
      return this.filteredRecords.slice(start, start + this.pageSize)
    },
    groupUsersDialogTitle() {
      return this.currentGroupView && this.currentGroupView.groupName ? `分组成员 - ${this.currentGroupView.groupName}` : '分组成员'
    },
    activeGroup() {
      return this.userGroups.find(item => item.id === this.activeGroupId) || null
    },
    groupCandidateUsers() {
      const list = Array.isArray(this.allFilteredRecords) ? this.allFilteredRecords : []
      const activeId = this.activeGroupId
      const keyword = String(this.groupMemberKeyword || '').trim().toLowerCase()
      return list.filter(row => {
        if (!row || !row.id) return false
        const groupIds = this.userGroupMap[row.id] || []
        if (activeId && groupIds.includes(activeId)) return false
        if (!keyword) return true
        const values = [row.userName, row.realName].map(v => String(v || '').toLowerCase())
        return values.some(v => v.includes(keyword))
      })
    },
    activeStudentUsers() {
      return (Array.isArray(this.activeGroupUsers) ? this.activeGroupUsers : []).filter(item => item && item.roleId == 1 && item.id)
    },
    summaryStats() {
      const list = this.filteredRecords
      return {
        total: list.length,
        students: list.filter(item => item.roleId === 1).length,
        teachers: list.filter(item => item.roleId === 2).length,
        organizations: list.filter(item => item.roleId === 6).length,
        vipStudents: list.filter(item => item.roleId === 1 && this.userHasAnyVipMembership(item.id)).length
      }
    }
  },
  created() {
    // 获取用户角色
    this.role = localStorage.getItem('roles')
    // 获取分页数据
    this.getUserPage()
    this.loadRepoList()
    this.loadUserGroups()
    console.log(this.role)
  },
  methods: {
    handleSelectionChange(rows) {
      this.selectedUsers = Array.isArray(rows) ? rows : []
    },
    handleGroupCandidateSelection(rows) {
      this.groupCandidateSelected = Array.isArray(rows) ? rows : []
    },
    formatRoleName(roleId) {
      if (roleId == 1) return '学生'
      if (roleId == 2) return '教师'
      if (roleId == 3) return '管理员'
      if (roleId == 4) return '年级主任'
      if (roleId == 5) return '家长'
      if (roleId == 6) return '机构'
      return '-'
    },
    async loadUserGroups() {
      try {
        const res = await listUserGroups()
        this.userGroups = (res && res.code === 1 && Array.isArray(res.data)) ? res.data : []
        if (this.userGroups.length) {
          const stillExists = this.userGroups.some(item => item.id === this.activeGroupId)
          this.activeGroupId = stillExists ? this.activeGroupId : this.userGroups[0].id
        } else {
          this.activeGroupId = null
          this.activeGroupUsers = []
        }
        await this.loadUserGroupsForCurrentPage(this.allFilteredRecords)
        if (this.activeGroupId) {
          await this.loadActiveGroupUsers()
        }
      } catch (e) {
        console.error('加载用户分组失败:', e)
      }
    },
    async loadUserGroupsForCurrentPage(recordsArg) {
      try {
        const records = Array.isArray(recordsArg) ? recordsArg : []
        const userIds = records.filter(r => r && r.id).map(r => r.id)
        if (!userIds.length) {
          this.userGroupMap = {}
          return
        }
        const res = await batchUserGroups(userIds)
        this.userGroupMap = (res && res.code === 1 && res.data) ? res.data : {}
      } catch (e) {
        console.error('加载用户分组映射失败:', e)
      }
    },
    getUserGroupNames(userId) {
      const groupIds = this.userGroupMap[userId] || []
      return groupIds.map(id => {
        const found = this.userGroups.find(item => item.id === id)
        return found ? found.groupName : ''
      }).filter(Boolean)
    },
    async selectActiveGroup(item) {
      if (!item || !item.id) return
      this.activeGroupId = item.id
      await this.loadActiveGroupUsers()
    },
    async loadActiveGroupUsers() {
      if (!this.activeGroupId) {
        this.activeGroupUsers = []
        return
      }
      const res = await listGroupUsers(this.activeGroupId)
      this.activeGroupUsers = (res && res.code === 1 && Array.isArray(res.data)) ? res.data : []
    },
    async saveGroup() {
      if (!this.groupForm.groupName) {
        this.$message.warning('请输入分组名称')
        return
      }
      const res = await saveUserGroup({ ...this.groupForm, status: 1 })
      if (res && res.code === 1) {
        this.$message.success('保存成功')
        this.groupDialogVisible = false
        this.groupForm = { groupName: '', description: '' }
        await this.loadUserGroups()
        if (res.data && res.data.id) {
          this.activeGroupId = res.data.id
          await this.loadActiveGroupUsers()
        }
      } else {
        this.$message.error((res && res.msg) || '保存失败')
      }
    },
    openAssignGroupDialog() {
      if (!this.selectedUsers.length) {
        this.$message.warning('请先勾选用户')
        return
      }
      this.assignGroupId = null
      this.assignGroupDialogVisible = true
    },
    async assignSelectedUsersToGroup() {
      if (!this.assignGroupId) {
        this.$message.warning('请选择分组')
        return
      }
      const userIds = this.selectedUsers.map(item => item.id).filter(Boolean)
      const res = await addUsersToGroup(this.assignGroupId, userIds)
      if (res && res.code === 1) {
        this.$message.success('加入分组成功')
        this.assignGroupDialogVisible = false
        await this.loadUserGroupsForCurrentPage(this.allFilteredRecords)
      } else {
        this.$message.error((res && res.msg) || '加入分组失败')
      }
    },
    async deleteGroup(item) {
      try {
        await this.$confirm(`确认删除分组“${item.groupName}”吗？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      const res = await deleteUserGroup(item.id)
      if (res && res.code === 1) {
        this.$message.success('删除成功')
        if (String(this.searchForm.searchGroupId) === String(item.id)) {
          this.searchForm.searchGroupId = ''
        }
        if (String(this.activeGroupId) === String(item.id)) {
          this.activeGroupId = null
          this.activeGroupUsers = []
        }
        await this.loadUserGroups()
      } else {
        this.$message.error((res && res.msg) || '删除失败')
      }
    },
    async openGroupUsersDialog(item) {
      await this.viewGroupUsers(item)
    },
    async viewGroupUsers(item) {
      this.currentGroupView = item
      this.groupUsersDialogVisible = true
      const res = await listGroupUsers(item.id)
      this.groupUsers = (res && res.code === 1 && Array.isArray(res.data)) ? res.data : []
    },
    openAddMembersDialogForActiveGroup() {
      if (!this.activeGroup) {
        this.$message.warning('请先选择分组')
        return
      }
      this.groupMemberKeyword = ''
      this.groupCandidateSelected = []
      this.groupMemberPickerVisible = true
    },
    async confirmAddMembersToActiveGroup() {
      if (!this.activeGroup || !this.activeGroup.id) {
        this.$message.warning('请先选择分组')
        return
      }
      const userIds = this.groupCandidateSelected.map(item => item.id).filter(Boolean)
      if (!userIds.length) {
        this.$message.warning('请先选择用户')
        return
      }
      const res = await addUsersToGroup(this.activeGroup.id, userIds)
      if (res && res.code === 1) {
        this.$message.success('加入分组成功')
        this.groupMemberPickerVisible = false
        this.groupCandidateSelected = []
        await this.loadUserGroupsForCurrentPage(this.allFilteredRecords)
        await this.loadActiveGroupUsers()
      } else {
        this.$message.error((res && res.msg) || '加入分组失败')
      }
    },
    async removeUserFromCurrentGroup(row) {
      if (!this.currentGroupView || !this.currentGroupView.id) return
      const res = await removeUserFromGroup(this.currentGroupView.id, row.id)
      if (res && res.code === 1) {
        this.$message.success('移除成功')
        await this.viewGroupUsers(this.currentGroupView)
        await this.loadUserGroupsForCurrentPage(this.allFilteredRecords)
        if (String(this.activeGroupId) === String(this.currentGroupView.id)) {
          await this.loadActiveGroupUsers()
        }
      } else {
        this.$message.error((res && res.msg) || '移除失败')
      }
    },
    async removeUserByGroup(group, row) {
      if (!group || !group.id || !row || !row.id) return
      const res = await removeUserFromGroup(group.id, row.id)
      if (res && res.code === 1) {
        this.$message.success('移除成功')
        await this.loadActiveGroupUsers()
        await this.loadUserGroupsForCurrentPage(this.allFilteredRecords)
        if (this.currentGroupView && String(this.currentGroupView.id) === String(group.id)) {
          await this.viewGroupUsers(group)
        }
      } else {
        this.$message.error((res && res.msg) || '移除失败')
      }
    },
    async updateMembershipsByRows(rows, tierCode, successText, loadingKey = 'groupMembershipBatchLoading') {
      const membershipTypes = this.getAllMembershipTypes()
      if (!membershipTypes.length) {
        this.$message.warning('未获取到可管理的会员类型')
        return
      }
      const studentRows = (Array.isArray(rows) ? rows : []).filter(row => row && row.roleId == 1 && row.id)
      if (!studentRows.length) {
        this.$message.warning('当前没有可操作的学生成员')
        return
      }
      this[loadingKey] = true
      try {
        const tasks = []
        studentRows.forEach(row => {
          membershipTypes.forEach(memberType => {
            tasks.push(
              upsertUserMembership({
                userId: row.id,
                courseTypeCode: memberType.courseTypeCode,
                subjectCode: memberType.subjectCode || null,
                tierCode: tierCode
              })
            )
          })
        })
        const results = await Promise.all(tasks)
        const failed = results.filter(res => !res || res.code !== 1)
        if (failed.length) {
          this.$message.error(`批量处理完成，但有 ${failed.length} 项失败`)
        } else {
          this.$message.success(successText.replace('{count}', studentRows.length))
        }
        await this.loadMembershipsForCurrentPage(this.allFilteredRecords)
      } catch (e) {
        console.error(e)
        this.$message.error(tierCode === 'VIP' ? '批量开通会员失败' : '批量撤回会员失败')
      } finally {
        this[loadingKey] = false
      }
    },
    async activateMembershipsByActiveGroup() {
      if (!this.activeGroup) {
        this.$message.warning('请先选择分组')
        return
      }
      try {
        await this.$confirm(`将为分组“${this.activeGroup.groupName}”中的 ${this.activeStudentUsers.length} 个学生开通全部会员，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      await this.updateMembershipsByRows(this.activeStudentUsers, 'VIP', '已为 {count} 个学生开通全部会员')
    },
    async revokeMembershipsByActiveGroup() {
      if (!this.activeGroup) {
        this.$message.warning('请先选择分组')
        return
      }
      try {
        await this.$confirm(`将撤回分组“${this.activeGroup.groupName}”中的 ${this.activeStudentUsers.length} 个学生全部会员，是否继续？`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      await this.updateMembershipsByRows(this.activeStudentUsers, 'FREE', '已撤回 {count} 个学生的全部会员')
    },
    buildMembershipKey(userId, courseTypeCode, subjectCode) {
      return `${userId}_${String(courseTypeCode || '').toUpperCase()}_${String(subjectCode || '').toUpperCase()}`
    },
    getIsVip(userId, courseTypeCode, subjectCode = '') {
      const key = this.buildMembershipKey(userId, courseTypeCode, subjectCode)
      return String(this.membershipMap[key] || 'FREE').toUpperCase() === 'VIP'
    },
    userHasAnyVipMembership(userId) {
      const prefix = `${userId}_`
      return Object.keys(this.membershipMap).some(key => key.indexOf(prefix) === 0 && String(this.membershipMap[key]).toUpperCase() === 'VIP')
    },
    async loadRepoList() {
      try {
        const res = await fetchRepoList()
        const list = (res && res.code === 1 && Array.isArray(res.data)) ? res.data : []
        this.allRepos = list.filter(r => r && r.title)
        this.membershipTypes = this.getAllMembershipTypes()
      } catch (e) {
        console.error('加载题库列表失败:', e)
      }
    },
    repoToMembershipType(repo) {
      const title = String(repo.title || '').trim().toUpperCase()
      if (title === 'AMC8' || title === 'AMC10' || title === 'AMC12') {
        return { label: repo.title, courseTypeCode: 'AMC', subjectCode: title }
      }
      if (title.includes('袋鼠') || title.includes('KANGAROO')) {
        return { label: repo.title, courseTypeCode: 'KANGAROO', subjectCode: title }
      }
      if (title.includes('GESP') || title.includes('CCF')) {
        return { label: repo.title, courseTypeCode: 'GESP', subjectCode: title }
      }
      return { label: repo.title, courseTypeCode: title, subjectCode: '' }
    },
    getAllMembershipTypes() {
      const types = []
      const seen = new Set()
      this.allRepos.forEach(repo => {
        const mt = this.repoToMembershipType(repo)
        const key = `${mt.courseTypeCode}_${mt.subjectCode}`
        if (!seen.has(key)) {
          seen.add(key)
          types.push(mt)
        }
      })
      return types
    },
    openMembershipDialog(row) {
      this.membershipDialogUserId = row.id
      this.membershipDialogUserName = row.realName || row.userName || ''
      this.membershipTypes = this.getAllMembershipTypes()
      this.membershipDialogVisible = true
    },
    async onToggleMembershipInDialog(memberType, val) {
      const row = { id: this.membershipDialogUserId }
      await this.onToggleMembership(row, memberType.courseTypeCode, memberType.subjectCode, val)
    },
    async onToggleMembership(row, courseTypeCode, subjectCode, val) {
      const userId = row && row.id
      if (!userId) return
      const ct = String(courseTypeCode || '').trim().toUpperCase()
      const sc = String(subjectCode || '').trim().toUpperCase()
      if (!ct) return
      const key = this.buildMembershipKey(userId, ct, sc)
      const oldTier = String(this.membershipMap[key] || 'FREE').toUpperCase()
      const newTier = val ? 'VIP' : 'FREE'
      try {
        this.$set(this.membershipMap, key, newTier)
        const res = await upsertUserMembership({ userId, courseTypeCode: ct, subjectCode: sc || null, tierCode: newTier })
        if (res && res.code === 1) {
          this.$message.success('更新成功')
        } else {
          this.$set(this.membershipMap, key, oldTier)
          this.$message.error((res && res.msg) || '更新失败')
        }
      } catch (e) {
        this.$set(this.membershipMap, key, oldTier)
        console.error(e)
        this.$message.error('更新失败')
      }
    },
    async openAmcOrderDialog(row) {
      this.amcOrderDialogVisible = true
      this.amcOrders = []
      this.amcOrderLoading = true
      try {
        const userId = row && (row.id || row.userId)
        if (!userId) {
          this.$message.error('用户ID为空，无法查询购买记录')
          return
        }
        const res = await listAmcOrdersByUserId(userId)
        if (res && res.code === 1) {
          this.amcOrders = Array.isArray(res.data) ? res.data : []
        } else {
          this.$message.error((res && res.msg) || '查询购买记录失败')
        }
      } catch (e) {
        console.error('查询购买记录失败:', e)
        this.$message.error('查询购买记录失败')
      } finally {
        this.amcOrderLoading = false
      }
    },
    // 分页查询用户
    async getUserPage(pageNum, pageSize, realName = null, gradeId = null, roleId = null) {
      this.pageNum = pageNum || 1
      this.pageSize = pageSize || this.pageSize || 10
      const params = {
        pageNum: 1,
        pageSize: 1000,
        realName: realName,
        gradeId: gradeId,
        roleId: roleId
      }
      const res = await userPaging(params)
      const pageData = res && res.data ? res.data : {}
      this.data = pageData
      this.allFilteredRecords = Array.isArray(pageData.records) ? pageData.records : []
      await this.loadMembershipsForCurrentPage(this.allFilteredRecords)
      await this.loadUserGroupsForCurrentPage(this.allFilteredRecords)
    },
    async loadMembershipsForCurrentPage(recordsArg) {
      try {
        const records = Array.isArray(recordsArg) ? recordsArg : ((this.data && Array.isArray(this.data.records)) ? this.data.records : [])
        const userIds = records.filter(r => r && r.roleId == 1 && r.id).map(r => r.id)
        if (!userIds.length) {
          this.membershipMap = {}
          return
        }
        const courseTypeCodes = [...new Set(this.membershipTypes.map(t => t.courseTypeCode).filter(Boolean))]
        const subjectCodes = [...new Set(this.membershipTypes.map(t => t.subjectCode).filter(Boolean))]
        if (!courseTypeCodes.length) courseTypeCodes.push('AMC', 'KANGAROO', 'GESP')
        const res = await batchUserMemberships({ userIds, courseTypeCodes, subjectCodes })
        const list = (res && res.code === 1 && Array.isArray(res.data)) ? res.data : []
        const next = {}
        list.forEach(it => {
          if (!it || !it.userId || !it.courseTypeCode) return
          const key = this.buildMembershipKey(it.userId, it.courseTypeCode, it.subjectCode)
          next[key] = String(it.tierCode || 'FREE').toUpperCase()
        })
        this.membershipMap = next
      } catch (e) {
        console.error(e)
      }
    },
    // 搜索功能用户
    searchUser() {
      this.pageNum = 1
      this.getUserPage(
        this.pageNum,
        this.pageSize,
        this.searchForm.searchRealName,
        this.searchForm.searchClass,
        this.searchForm.searchRoleId
      )
    },
    // 设置每页多少条逻辑
    handleSizeChange(val) {
      this.pageSize = val
      this.pageNum = 1
    },
    // 设置当前页逻辑
    handleCurrentChange(val) {
      this.pageNum = val
    },
    async fetchAllFilteredStudents() {
      return this.filteredRecords.filter(row => row && row.roleId == 1 && row.id)
    },
    async updateMembershipsByCurrentFilter(tierCode, confirmText, successText, loadingKey) {
      if (Number(this.searchForm.searchRoleId) !== 1) {
        this.$message.warning('请先选择学生角色后再执行一键开通')
        return
      }
      const membershipTypes = this.getAllMembershipTypes()
      if (!membershipTypes.length) {
        this.$message.warning('未获取到可开通的会员类型')
        return
      }
      const studentRows = await this.fetchAllFilteredStudents()
      if (!studentRows.length) {
        this.$message.warning('当前筛选结果中没有学生用户')
        return
      }
      try {
        await this.$confirm(confirmText.replace('{count}', studentRows.length), '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
      } catch (e) {
        return
      }
      this[loadingKey] = true
      try {
        const tasks = []
        studentRows.forEach(row => {
          membershipTypes.forEach(memberType => {
            tasks.push(
              upsertUserMembership({
                userId: row.id,
                courseTypeCode: memberType.courseTypeCode,
                subjectCode: memberType.subjectCode || null,
                tierCode: tierCode
              })
            )
          })
        })
        const results = await Promise.all(tasks)
        const failed = results.filter(res => !res || res.code !== 1)
        if (failed.length) {
          this.$message.error(`批量开通完成，但有 ${failed.length} 项失败`)
        } else {
          this.$message.success(successText.replace('{count}', studentRows.length))
        }
        await this.loadMembershipsForCurrentPage()
      } catch (e) {
        console.error(e)
        this.$message.error(tierCode === 'VIP' ? '批量开通会员失败' : '批量撤回会员失败')
      } finally {
        this[loadingKey] = false
      }
    },
    async activateMembershipsByCurrentFilter() {
      await this.updateMembershipsByCurrentFilter(
        'VIP',
        '将为当前筛选结果中的 {count} 个学生开通全部会员，是否继续？',
        '已为 {count} 个学生开通全部会员',
        'bulkActivateLoading'
      )
    },
    async revokeMembershipsByCurrentFilter() {
      await this.updateMembershipsByCurrentFilter(
        'FREE',
        '将撤回当前筛选结果中的 {count} 个学生全部会员，是否继续？',
        '已撤回 {count} 个学生的全部会员',
        'bulkRevokeLoading'
      )
    },
    // 添加用户逻辑
    addUser() {
      const data = {
        userName: this.addForm.userName,
        realName: this.addForm.realName,
        roleId: this.addForm.roleId,
        gradeId: this.addForm.gradeId
      }
      classAdd(data).then((res) => {
        if (res.code) {
          // 清空新增用户表单
          this.addForm.userName = ''
          this.addForm.realName = ''
          this.addForm.roleId = ''
          this.addForm.gradeId = ''
          // 刷新页面数据
          this.getUserPage(this.pageNum, this.pageSize)
          // 关闭新增用户对话框
          this.addUserDiologVisible = false
          this.$message({
            type: 'success',
            message: '新增成功!'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 上传文件逻辑
    importUser() {
      if (this.fileList.length > 0) {
        const formData = new FormData() // 创建FormData对象
        formData.append('file', this.fileList[0].raw) // 添加文件到formData
        userImport(formData)
          .then((response) => {
            if (response.code) {
              this.getUserPage(this.pageNum, this.pageSize)
              this.$message.success(`${response.msg}`)
              this.fileDialogVisible = false // 关闭对话框
            } else {
              this.$message.error(`${response.msg}`)
            }

            // 可以在这里处理成功后的逻辑，如刷新数据等
          })
          .catch((error) => {
            console.error('文件上传失败：', error)
            this.$message.error('文件上传失败！')
          })
      } else {
        this.$message.warning('请选择文件后再上传！')
      }
    },
    // 上传文件出触发
    handleFileChange(file, fileList) {
      this.fileList = fileList // 收集文件信息
    },
    // 移除文件处理方法
    handleRemove(file, fileList) {
      if (fileList.length === 0) {
        this.hasFiles = false
      }
    },
    // 删除用户方法
    delUser(row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      })
        .then(() => {
          userDel(row.id).then((res) => {
            if (res.code) {
              // 刷新页面数据
              this.getUserPage(this.pageNum, this.pageSize)
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 将用户移出班级
    removeUserClass(row) {
      userClassRemove(row.id).then((res) => {
        if (res.code) {
          // 刷新页面数据
          this.getUserPage(this.pageNum, this.pageSize)
          this.$message({
            type: 'success',
            message: '移除成功!'
          })
        } else {
          this.$message({
            type: 'info',
            message: res.msg
          })
        }
      })
    },
    // 下载模板
    async startDownload() {
      const a = document.createElement('a')
      a.href = './template/ImportUserTemplate.xlsx'
      a.download = '导入用户模板.xlsx'
      // 障眼法藏起来a标签
      a.style.display = 'none'
      // 将a标签追加到文档对象中
      document.body.appendChild(a)
      // 模拟点击了<a>标签,会触发<a>标签的href的读取,浏览器就会自动下载了
      a.click()
      // 一次性的,用完就删除a标签
      a.remove()
    }
  }
}
</script>
<style>
.el-table--border,
.el-table--group {
  border: 1px solid #b3b3b3;
}

.summary-cards {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 12px;
  margin: 0 0 16px;
}

.group-management-panel {
  display: grid;
  grid-template-columns: 300px 1fr;
  gap: 16px;
  margin: 0 0 16px;
}

.group-management-panel__sidebar,
.group-management-panel__content {
  background: #fff;
  border: 1px solid #ebeef5;
  border-radius: 10px;
  padding: 16px;
}

.group-management-panel__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.group-management-panel__title {
  font-size: 16px;
  font-weight: 700;
  color: #303133;
}

.group-management-panel__subtitle {
  margin-top: 4px;
  color: #909399;
  font-size: 13px;
}

.group-card-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.group-card {
  border: 1px solid #ebeef5;
  border-radius: 8px;
  padding: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.group-card:hover,
.group-card--active {
  border-color: #409EFF;
  background: #f0f7ff;
}

.group-card__main {
  margin-bottom: 8px;
}

.group-card__name {
  font-weight: 700;
  color: #303133;
  margin-bottom: 4px;
}

.group-card__desc {
  color: #909399;
  font-size: 12px;
  line-height: 1.5;
}

.group-card__actions {
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}

.group-detail-summary {
  padding: 12px 14px;
  margin-bottom: 12px;
  background: #f7f9fc;
  border: 1px solid #ebeef5;
  border-radius: 8px;
}

.group-detail-summary__name {
  font-size: 15px;
  font-weight: 700;
  color: #303133;
}

.group-detail-summary__desc,
.group-detail-summary__meta,
.group-empty-state {
  color: #909399;
  font-size: 13px;
}

.group-detail-summary__desc {
  margin: 6px 0;
}

.group-member-picker__toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  gap: 12px;
}

.summary-card {
  padding: 16px;
  border-radius: 10px;
  background: #f7f9fc;
  border: 1px solid #e8eef7;
}

.summary-card__label {
  font-size: 13px;
  color: #606266;
  margin-bottom: 8px;
}

.summary-card__value {
  font-size: 24px;
  line-height: 1;
  font-weight: 700;
  color: #303133;
}
</style>
